import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Masks from '../../utils/masks';
import { Button, Grid, Modal, Input } from '../../components/index';
import {
  doPut,
  trataMensagemSucesso,
} from '../../utils/requests';

class ModalAlteracaoDataEMotivoCessacao extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    motivoCessacaoManual: this.props.motivoCessacaoManual,
    dataCessacaoBeneficio: this.props.dataCessacaoBeneficio,
    touched: false,
  });

  checkIfFileCanBeSent = () => (
    this.state.dataCessacaoBeneficio &&
    (this.state.motivoCessacaoManual || this.state.motivoCessacaoManual === '')
  );

  diffRequerimento = () => {
    const { tipoRequerimento } = { ...this.props };
    if (tipoRequerimento === 2) {
      return 'pensao';
    }
    return 'aposentadoria';
  }

  handleSave = () => {
    const tipo = this.diffRequerimento();
    const url = `alterar-data-cessacao-requerimento-${tipo}`;
    const { protocolo } = { ...this.props };
    const { dataCessacaoBeneficio } = { ...this.state };
    const { motivoCessacaoManual } = { ...this.state };
    const objProtocolo = protocolo;
    let objMotivoCessacaoManual = motivoCessacaoManual;
    if (objMotivoCessacaoManual === '') {
      objMotivoCessacaoManual = null;
    }
    const objAlteracao = { protocolo: objProtocolo, motivoCessacaoManual: objMotivoCessacaoManual, dataCessacao: dataCessacaoBeneficio };
    let options;
    if (this.state.chaveConfirmacao) {
      options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
    }
    doPut(
      url,
      objAlteracao,
      this.trataSucessoResponseEnvio,
      this.trataErrosResponse,
      options,
    );
  }

  trataSucessoResponseEnvio = () => {
    this.handleClose();

    this.props.atualizarDataCessacao(this.state.dataCessacaoBeneficio);
    this.props.atualizarMotivoCessacao(this.state.motivoCessacaoManual);

    // Adiciona o histórico para bloquear o lápis
    const novoHistorico = {
      descricao: 'Informação de data e motivo de cessação',
    };

    this.props.atualizarHistoricoAuditorias(novoHistorico);

    trataMensagemSucesso([
      'Data e motivo de cessação do benefício alterados',
    ]);
  }

  filterMotivos = (lista, requerimento, tipo) => {
    let motivosCessacaoFiltrado = [];
    const codigoTipo = tipo === 'aposentadoria' ? 1 : 2;
    const inss = '01000';

    let destinatarioOuSolicitanteRGPS = false;
    let regimes = [2, 3];

    if (requerimento.solicitante) {
      destinatarioOuSolicitanteRGPS = [
        requerimento.solicitante.codigo,
        requerimento.destinatario.codigo,
      ].includes(inss);

      if (requerimento.solicitante.codigo === inss) {
        regimes = [1, 3];
      }
    }

    const acordos = destinatarioOuSolicitanteRGPS ? [1, 3] : [2, 3];

    motivosCessacaoFiltrado = lista.filter(motivo => (
      motivo.abrangenciaAplicavel === codigoTipo &&
      regimes.includes(motivo.regimeAplicavel) &&
      acordos.includes(motivo.acordoAplicavel)
    ));

    return motivosCessacaoFiltrado;
  };

  modalContent = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="6 6 12 12">
          <Input
            label="Data de Cessação"
            mask={Masks.date}
            value={this.state.dataCessacaoBeneficio}
            onChange={e => this.handleChange(e, 'dataCessacaoBeneficio')}
            touched={this.state.touched}
          />
        </Grid>
      </div>

      <div className="row">
        <Grid cols="8 8 12 12">
          <Input
            label="Motivo Cessação"
            number
            placeholder="Selecione o Motivo da Cessação"
            onChange={e => this.handleChange(e, 'motivoCessacaoManual')}
            value={this.state.motivoCessacaoManual}
            itemList={this.filterMotivos(
              this.props.motivosCessacao,
              this.props.estadoFormulario.requerimento,
              'aposentadoria',
            )}
            required
            custom
          />
        </Grid>
      </div>
    </React.Fragment>
  )

  modalFooter = () => (
    <React.Fragment>
      <div className="right">
        <Button
          className="dtp-primary"
          disabled={!this.checkIfFileCanBeSent()}
          hint="Salvar"
          onClick={this.handleSave}
          title="Salvar"
        />
      </div>
    </React.Fragment>
  )

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    });
  }

  handleClose = () => {
    this.props.handleModal('exibirModalDataEMotivoCessacao');
  }

  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalFooter()}
        conteudomodal={this.modalContent()}
        onHide={this.handleClose}
        size="md"
        showModal={this.props.showModal}
        title="Alterar data e motivo de cessação"
      />
    );
  }
}

ModalAlteracaoDataEMotivoCessacao.propTypes = {
  tipoRequerimento: PropTypes.number.isRequired,
  protocolo: PropTypes.string.isRequired,
  dataCessacaoBeneficio: PropTypes.string.isRequired,
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  atualizarDataCessacao: PropTypes.func,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  atualizarMotivoCessacao: PropTypes.func,
  atualizarHistoricoCessacao: PropTypes.func, // NOVA PROP
}.isRequired;

const mapStateToProps = state => ({
  motivosCessacao: state.base.motivosCessacao,
});

export default connect(mapStateToProps)(ModalAlteracaoDataEMotivoCessacao);



// WEBPACK FOOTER //
// ./src/pages/requerimentos/ModalAlteracaoDataEMotivoCessacao.jsx